import { render, staticRenderFns } from "./QtimeReports.vue?vue&type=template&id=1cc70852&scoped=true&"
import script from "./QtimeReports.vue?vue&type=script&lang=js&"
export * from "./QtimeReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc70852",
  null
  
)

export default component.exports